import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	const [{ query }] = useRouter();

	return <ScreenRedirect to={`/jira/plans/reports/${query.r}`} persistSearchParams={false} />;
};
